import { adminCall, adminGet } from '../../api/adminCall';

export async function adminListImpersonationLogs(params = {}) {
  const qs = new URLSearchParams();
  if (params.adminEmail) qs.set('adminEmail', params.adminEmail);
  if (params.targetUserEmail) qs.set('targetUserEmail', params.targetUserEmail);
  if (params.companyName) qs.set('companyName', params.companyName);
  if (params.status) qs.set('status', params.status);
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.cursor) qs.set('cursor', params.cursor);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return adminGet(`/api/admin/impersonation-logs${suffix}`);
}

export async function adminCreateImpersonationLog(payload) {
  const result = await adminCall('/api/admin/impersonation-logs', payload || {});
  return result.log || null;
}
